import { useQuery } from '@tanstack/react-query'

import { type GetAllItemOptions, getAllItems } from '@flecto/api/store'

export type UseQueryGetAllItemsOptions = {
  storeDomain?: string
  options?: GetAllItemOptions & {
    enabled?: boolean
    keepPreviousData?: boolean
  }
}

export function useQueryGetAllItems({
  storeDomain,
  options,
}: UseQueryGetAllItemsOptions) {
  return useQuery({
    queryKey: ['QueryGetAllItems', storeDomain, options],
    queryFn: async () => {
      const filters = { ...options }

      if ('keepPreviousData' in filters) {
        delete filters.keepPreviousData
      }

      if ('enabled' in filters) {
        delete filters.enabled
      }

      return await getAllItems(storeDomain ?? '', filters)
    },
    refetchOnWindowFocus: false,
    enabled: options?.enabled,
    keepPreviousData: options?.keepPreviousData,
  })
}
